import React from "react";
import { createRoot } from "react-dom/client";
import Portfolio from "../../javascript/components/portfolio/projects/IndexProjectList";
import "../../assets/stylesheets/modules/portfolio/index.scss";
import "../../assets/stylesheets/modules/portfolio/projects.scss";

const mountPortfolio = () => {
  const rootElement = document.getElementById("portfolio-root");
  if (!rootElement || rootElement.dataset.mounted === "true") return;

  rootElement.dataset.mounted = "true";
  const images = JSON.parse(rootElement.dataset.images || "{}");
  createRoot(rootElement).render(<Portfolio images={images} />);
};

document.addEventListener("DOMContentLoaded", mountPortfolio);
document.addEventListener("turbo:load", mountPortfolio);
mountPortfolio();
